/**
 * eslint-disable react/no-children-prop,no-unused-vars
 *
 * @format
 */

import React from "react";
import { Dropzone } from "@mantine/dropzone";
import {
  Button,
  Progress,
  Text,
  ActionIcon,
  Checkbox,
  Anchor,
} from "@mantine/core";
import { BeatLoader } from "react-spinners";
import { showNotification } from "@mantine/notifications";
import { Trash } from "tabler-icons-react";
import { IconFileText } from "@tabler/icons-react";
import colors from "../../utilities/design";
import { loadingStates } from "../../utilities/utilities";
import styles from "./NewDocumentUploader.module.css";

const NewDocumentUploader = ({
  multiUploadArgs,
  hideDropZone,
  hideDeleteButton,
  hideOpenButton,
  checkBoxShow = false,
  fileNameHidden = false,
}) => {
  const {
    addFiles,
    addUploadedFiles,
    deleteFile,
    checkFile,
    downloadFile,
    finalFiles,
    files,
    loadingFromParent,
  } = multiUploadArgs;
  console.log("multipleargs: ", multiUploadArgs);
  return (
    <div className="flex flex-col px-2">
      {!hideDropZone && (
        <Dropzone
          onDrop={addFiles}
          onReject={(filesIncoming) =>
            showNotification({
              color: "red",
              title: "Files rejected",
              message: `${filesIncoming.length} files rejected.`,
            })
          }
          maxSize={1024 * 1024 * 25}
          // maxFiles={1}
        >
          <div
            className={`${styles.dropBox} flex flex-col justify-center mt-1`}
          >
            <img src="/assets/images/download.svg" alt="downloadlogo" />
            <div className="mt-3">Drop or select files upto 25MB each</div>
          </div>
        </Dropzone>
      )}
      <div className="flex flex-col gap-3 mt-4">
        {files.map((file, index) => (
          <div
            key={
              file.fileId ||
              file.id ||
              file.uploadId ||
              `${file.fileName}-${file.size}-${index}`
            }
            className={`flex flex-row items-center gap-3 w-full p-3 border rounded-lg transition-colors ${
              checkBoxShow && file.uploaded
                ? "cursor-pointer " +
                  (file.checked
                    ? "border-blue-400 bg-blue-50"
                    : "border-gray-200 bg-white hover:border-gray-300")
                : "border-gray-200 bg-white hover:border-gray-300"
            }`}
            onClick={
              checkBoxShow && file.uploaded ? checkFile(index) : undefined
            }
          >
            {checkBoxShow && file.uploaded && (
              <Checkbox
                color="dark"
                size="md"
                className="cursor-pointer flex-shrink-0"
                checked={file.checked}
                onChange={checkFile(index)}
                onClick={(e) => e.stopPropagation()}
              />
            )}
            <div className="flex items-center justify-center w-9 h-9 rounded-md bg-slate-100 flex-shrink-0">
              <IconFileText size={18} className="text-slate-500" />
            </div>
            {!fileNameHidden && (
              <div className="flex flex-col flex-1 min-w-0 gap-2">
                <div className={`${styles.agrement} truncate`}>
                  {file.fileName}
                </div>
                {!file.uploaded && (
                  <Progress
                    color={file.errored ? "red" : "teal"}
                    size="sm"
                    animate={
                      file.fetchingUploadUrl ||
                      file.attaching === loadingStates.LOADING
                    }
                    value={
                      file.fetchingUploadUrl || file.errored
                        ? 100
                        : file.uploadPercentage
                    }
                  />
                )}
              </div>
            )}
            <div className="flex items-center gap-2 flex-shrink-0">
              {file.uploaded && !hideOpenButton && !fileNameHidden ? (
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    downloadFile(index)();
                  }}
                  className="w-32"
                  color="#1b6f8d"
                  disabled={file.downloading === loadingStates.LOADING}
                  variant="outline"
                  style={{
                    color: "#46BDE1",
                    borderColor: "#46BDE1",
                  }}
                >
                  {file.downloading === loadingStates.LOADING ? (
                    <BeatLoader size={10} color={colors.primary} />
                  ) : (
                    <Text>Open</Text>
                  )}
                </Button>
              ) : null}
              {file.uploaded && !hideOpenButton && fileNameHidden ? (
                <Anchor
                  onClick={(e) => {
                    e.stopPropagation();
                    downloadFile(index)();
                  }}
                  className="w-60"
                  color="#1b6f8d"
                  disabled={file.downloading === loadingStates.LOADING}
                >
                  {file.downloading === loadingStates.LOADING ? (
                    <BeatLoader size={10} color={colors.primary} />
                  ) : (
                    <Text>{file.fileName}</Text>
                  )}
                </Anchor>
              ) : null}
              {(file.uploaded || file.errored) && !hideDeleteButton && (
                <ActionIcon
                  color="red"
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteFile(index)();
                  }}
                >
                  <Trash size={18} />
                </ActionIcon>
              )}
            </div>
          </div>
        ))}
      </div>
      {loadingFromParent === loadingStates.LOADING && (
        <div className="flex justify-center w-full my-4">
          {" "}
          <BeatLoader size={10} color={colors.primary} />{" "}
        </div>
      )}
      {files.length === 0 &&
        loadingFromParent !== loadingStates.LOADING &&
        !fileNameHidden && (
          <div className="flex justify-center w-full my-4">
            <Text>No Files</Text>
          </div>
        )}
      {files.length === 0 &&
        loadingFromParent !== loadingStates.LOADING &&
        fileNameHidden && (
          <div className="flex w-full my-4">
            <Text>No Files</Text>
          </div>
        )}
    </div>
  );
};

export default NewDocumentUploader;
